import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

// breakpoints 1020px

export const useStyles = (open: boolean, isHeaderExpanded: boolean) => {
  return makeStyles({
    mainContainer: {
      position: 'sticky',
      top: 0,
      zIndex: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: open ? 'center' : 'space-between',
      columnGap: '4px',
      padding: '20px 8px',

      [theme.breakpoints.up('sm')]: {
        padding: '20px 15px',
      },

      [theme.breakpoints.up('md')]: {
        padding: '0',
        height: '80px',
      },
    },

    countryAvatarWrapper: {
      display: open ? 'none' : 'block',
      flex: isHeaderExpanded ? 1 : 0,
      [theme.breakpoints.up('sm')]: {
        flex: 1,
      },
    },

    logoAvatarWrapper: {
      display: 'flex',
      alignItems: 'center',
      columnGap: '10px',

      [theme.breakpoints.up('sm')]: {
        columnGap: '30px',
      },

      [theme.breakpoints.up('md')]: {
        paddingLeft: '50px',
      },
    },

    faqAndCartWrapper: {
      display: open ? 'none' : 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '80px',
      flex: isHeaderExpanded ? 1 : 0,
      [theme.breakpoints.up('sm')]: {
        flex: 1,
      },
      [theme.breakpoints.down(1400)]: {
        columnGap: '20px',
      },
    },

    cartBagWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      columnGap: '15px',
      backgroundColor: theme.palette.cinnamon.main,
      width: '150px',
      height: '80px',
      cursor: 'pointer',

      [theme.breakpoints.down('lg')]: {
        width: '125px',
        columnGap: '10px',
      },

      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },

    selectBox: {
      padding: '8px 15px 8px 20px',
      alignItems: 'center',
      borderRadius: '30px',
      backgroundColor: theme.palette.turmeric.main,
    },

    roundBtnWrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: '15px',

      [theme.breakpoints.down('lg')]: {
        columnGap: '5px',
      },
    },

    planBtnContainer: {
      width: '100vw',
      padding: '15px 25px 40px',
      //backgroundColor: theme.palette.whitePepper.main,
      position: 'absolute',
      top: '80px',
      zIndex: 100,
      justifyContent: 'center',

      [theme.breakpoints.down('lg')]: {
        top: '70px',
      },
      [theme.breakpoints.down('md')]: {
        padding: '15px 25px 25px',
      },
    },

    planBtnWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },

    btnWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '55px',
      margin: '0 auto',
      width: '360px',
      height: '90px',
      overflow: 'hidden',
    },

    planAmountWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    planAmount: {
      display: 'flex',
      justifyContent: 'center',
      padding: '8px 5px',
    },
  });
};
